define(['jquery'], function($) {
    $(function() {
        var $regionsBlock = $('.product-regions');
        var $radio = $regionsBlock.find('input[name=product-criteria-radio]:checked');
        var $productRegionItem = $regionsBlock.find('.product-region-item');

        if ($radio.length > 0) {
            $regionsBlock.find('.region-tab').addClass('disabled');
            $radio.parents('.region-tab').removeClass('disabled');
            $productRegionItem.removeClass('active-region');
            $regionsBlock.find('#region-item-' + $radio.data('region')).addClass('active-region');
        }

        if ($productRegionItem.length > 1) {
            $productRegionItem.on('click', function() {
                $productRegionItem.toggleClass('active-region');
                $regionsBlock.find('.region-tab').toggleClass('disabled');
            });
        }
    });
});
